var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAvailable
    ? _c(
        "b-btn",
        {
          staticClass: "btn-card-action btn-danger my-1",
          attrs: { target: "_blank", to: _vm.link },
        },
        [
          _vm._v(" Ответить на запрос"),
          _c("br"),
          _vm._v(
            "(До " +
              _vm._s(
                _vm.getDateTimeFormat(
                  _vm.purchase.purchase_info.explanation_request_answer_end_date
                )
              ) +
              ") "
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }